import { useMutation } from '@tanstack/react-query';
import { useNotification } from 'src/hooks/useNotification';
import { ContributeService } from 'src/services/api';

export const useMutateCreateContributionComment = () => {
  const { notification } = useNotification();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: { dataUuid: string; noteId: number; body: { comment: string } }) =>
      ContributeService.createContributionComment(payload),
    onSettled: (response) => {
      if (!response) return;
      notification({ ...response });
    },
  });

  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateUpdateContributionComment = () => {
  const { notification } = useNotification();

  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: { dataUuid: string; noteId: number; commentId: number; body: { comment: string } }) =>
      ContributeService.updateContributionComment(payload),
    onSettled: (response) => {
      if (!response) return;
      notification({ ...response });
    },
  });

  return {
    isPending,
    mutateAsync,
  };
};

export const useMutateDeleteContributionComment = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: { dataUuid: string; noteId: number; commentId: number }) =>
      ContributeService.deleteContributionComment(payload),
  });

  return {
    isPending,
    mutateAsync,
  };
};
